import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { setSelectedAccident } from "../../../../actions/accidentDashboard";
import {
  cleanAuthorizationsWithFilters,
  getAuthorizationsWithFilters,
} from "../../../../actions/authorizations";
import { convertDateTimeToNet } from "../../../../utils/datetimeUtils";
import AnsweredAuthorizationsTable from "../../../commons/table/answeredAuthorizationsTable";
import { StyledSearchContainer } from "../../../styled/authorizations";
import AccidentDashboardContainer from "../../accident/accidentDashboard/accidentDashboardContainer";
import FormContainer from "../../forms/formContainer";
import SearchAuthorizationsForm from "./searchAuthorizationsForm";

const initialSearchValues = {
  siniestro: "",
  dni: "",
  fechaDesde: convertDateTimeToNet(new Date()),
  fechaHasta: convertDateTimeToNet(new Date()),
  otrosPrestadores: false,
};

const AuthorizationsSearchContainer = () => {
  const dispatch = useDispatch();
  const authorizations = useSelector((state) => state.authorizations);
  const art = useSelector((state) => state.art);

  const [displayAccidents, setDisplayAccidents] = useState("block");
  const [searchFilters, setSearchFilters] = useState(initialSearchValues);

  useEffect(() => {
    dispatch(cleanAuthorizationsWithFilters());
  }, []);

  const handleSearch = (values) => {
    const searchModel = {
      ...values,
      fechaDesde: values.fechaDesde
        ? convertDateTimeToNet(values.fechaDesde)
        : "",
      fechaHasta: values.fechaHasta
        ? convertDateTimeToNet(values.fechaHasta)
        : "",
    };

    setSearchFilters(searchModel);
    dispatch(getAuthorizationsWithFilters(searchModel));
  };

  const handleAccidentDetail = (accident) => {
    dispatch(
      setSelectedAccident({
        ...accident,
        mlCloudCoreArtId: accident.artMLCloud,
        idSiniestro: accident.siniestroId,
      }),
    );
    setDisplayAccidents("none");
  };

  return (
    <StyledSearchContainer.Container>
      {displayAccidents === "none" && (
        <AccidentDashboardContainer setDisplayAccidents={setDisplayAccidents} />
      )}
      {displayAccidents !== "none" && (
        <div>
          <StyledSearchContainer.Title>
            Buscar Autorización
          </StyledSearchContainer.Title>
          <SearchAuthorizationsForm
            handleSubmit={handleSearch}
            loading={authorizations.isFetchingFilter}
          />
        </div>
      )}
      <AnsweredAuthorizationsTable
        data={authorizations.listFilter.authorizations || []}
        loading={authorizations.isFetchingFilter}
        error={authorizations.didInvalidate}
        namesArts={art.list}
        // cuando se agrega un turno/sesiones a una autorización, queremos
        // que se actualice el ícono de cantidad de turnos
        fetchData={() => dispatch(getAuthorizationsWithFilters(searchFilters))}
        title="Autorizaciones"
        isSearch={true}
        handleAccidentDetail={handleAccidentDetail}
        displayAccidents={displayAccidents}
      />
      <FormContainer />
    </StyledSearchContainer.Container>
  );
};

export default AuthorizationsSearchContainer;
